import ReportsTransactionTableItem from './ReportsTransactionTableItem'

export default ReportsTransactionTableItem
